import { Button, Link, SimpleText, useGeneratePath, useStaticUrls } from 'platform-components';
import { getIsContentManager } from 'platform-components/src/components/user/selectors';
import React from 'react';
import { useSelector } from 'react-redux';

import * as lessonSelectors from 'common.components/lesson/selectors';

import { SidePanelControlTypeProps } from '../typings';

export const SidePanelControlsTypeGotoCustomFlowLessonEditor = React.memo((props: SidePanelControlTypeProps) => {
    const { notifyCanBeRender, notifyCanNotBeRender } = props;
    const getRouterPath = useGeneratePath();
    const staticUrls = useStaticUrls();
    const isContentManager = useSelector(getIsContentManager);
    const clessonId = useSelector(lessonSelectors.getCLessonId);
    const isCustomFlow = useSelector(lessonSelectors.getIsCustomFlowLesson);

    if (!isCustomFlow || !isContentManager || !clessonId) {
        notifyCanNotBeRender();
        return null;
    }

    const to = getRouterPath(staticUrls.cmCustomFlowLessonEdit, { clessonId });
    notifyCanBeRender();

    return (
        <Link target="_blank" to={to}>
            <Button accent={Button.ACCENT.NORMAL} view={Button.VIEW.CLEAR}>
                <SimpleText id="lessonModal.controls.gotoCustomFlowLessonEditor" />
            </Button>
        </Link>
    );
});
